import { Activity, Server, Users, Zap } from 'lucide-react';
import { StatisticCard } from '@/design-system';
import type { ServerStats } from '../api/whatsapp-servers.service';

export function WhatsAppServerStatsCards({ stats }: { stats: ServerStats }) {
  const { global } = stats;
  return <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
    <StatisticCard appearance="highlight" tone="neutral" icon={Server} title="Total de servidores"
      value={`${global.totalServers} (${global.activeServers} ativos)`} />
    <StatisticCard appearance="highlight" tone="primary" icon={Users} title="Capacidade total" value={global.totalCapacity} />
    <StatisticCard appearance="highlight" tone={global.utilizationRate >= 90 ? 'warning' : 'success'} icon={Activity}
      title={`Utilização (${global.currentLoad}/${global.totalCapacity})`} value={`${global.utilizationRate}%`} />
    <StatisticCard appearance="highlight" tone="primary" icon={Zap} title="Slots disponíveis" value={global.availableSlots} />
  </div>;
}
